var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      on: {
        click: function ($event) {
          $event.stopPropagation()
          return _vm.phoneClick.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "a-select",
        {
          ref: "phoneCode",
          staticClass: "phoneCode",
          attrs: {
            value: _vm._f("disCountryCode")(_vm.form.phoneCode),
            dropdownMatchSelectWidth: false,
            open: _vm.open,
            getPopupContainer: _vm.getPopupContainer
              ? _vm.getPopupContainer
              : () => _vm.$el,
            dropdownClassName: "entry-phoneCode",
          },
        },
        [
          _c(
            "div",
            { attrs: { slot: "suffixIcon" }, slot: "suffixIcon" },
            [
              _c("icon-font", {
                staticStyle: { transition: "all 0.3s" },
                style: { transform: _vm.open ? `rotate(180deg)` : "" },
                attrs: { type: "gb-icon-Down" },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: { overflow: "auto", padding: "4px 0" },
              style: {
                minWidth: _vm.currentLang === "zh_CN" ? "260px" : "400px",
              },
              attrs: { slot: "dropdownRender" },
              slot: "dropdownRender",
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "center",
                    width: "100%",
                    margin: "8px 0",
                  },
                },
                [
                  _c("a-input", {
                    staticStyle: { width: "90%" },
                    attrs: {
                      placeholder: _vm.$t("common_login_输入地区模糊查询"),
                    },
                    on: { change: _vm.onSearch },
                    model: {
                      value: _vm.searchCode,
                      callback: function ($$v) {
                        _vm.searchCode = $$v
                      },
                      expression: "searchCode",
                    },
                  }),
                ],
                1
              ),
              _vm.filterCodeList.length
                ? _c("RecycleScroller", {
                    staticStyle: {
                      "max-height": "256px",
                      "min-height": "32px",
                      overflow: "auto",
                    },
                    attrs: {
                      items: _vm.filterCodeList,
                      "item-size": 32,
                      buffer: 100,
                      prop: {
                        value: "index",
                        text: "name" + _vm.currentLangList[_vm.currentLang],
                      },
                    },
                    on: { selected: _vm.changeInternational },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({ item }) {
                            return [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "justify-content": "space-between",
                                    width: "100%",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        width: "calc(100% - 70px)",
                                        "white-space": "nowrap",
                                        "text-overflow": "ellipsis",
                                        overflow: "hidden",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          item[
                                            "name" +
                                              _vm.currentLangList[
                                                _vm.currentLang === "ko_KR"
                                                  ? "en_US"
                                                  : _vm.currentLang
                                              ]
                                          ]
                                        )
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "span",
                                    { staticStyle: { "margin-right": "2px" } },
                                    [_vm._v("+ " + _vm._s(item.phonecode))]
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      730798007
                    ),
                  })
                : _c(
                    "a-empty",
                    {
                      attrs: {
                        "image-style": {
                          height: "60px",
                        },
                        image: _vm.simpleImage,
                      },
                    },
                    [
                      _c(
                        "span",
                        { attrs: { slot: "description" }, slot: "description" },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("layouts.text.undefined")) + " "
                          ),
                        ]
                      ),
                    ]
                  ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }